<template>
  <div>
    <b-row>
      <!-- ป้าย VMS -->
      <b-col
        xl="6"
        lg="6"
        md="6"
        sm="12"
        xs="12"
        class="mb-1"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div style="font-size: 20px;">
            <b-img
              class="mr-1"
              height="30"
              src="@/assets/images/icons/chartg.svg"
            />
            <strong>กราฟความเร็วลม (วัน)</strong>
            <!-- <em>word wrap</em> -->
          </div>

          <div class="mt-2">
            <app-echar-line
              :option-data="optionwind"
            />
          </div>
        </b-card>
      </b-col>

      <b-col
        xl="6"
        lg="6"
        md="6"
        sm="12"
        xs="12"
        class="mb-1"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div style="font-size: 20px;">
            <b-img
              class="mr-1"
              height="30"
              src="@/assets/images/icons/chartw.svg"
            />
            <strong>กราฟน้ำฝน (วัน)</strong>
            <!-- <em>word wrap</em> -->
          </div>
          <div class="mt-2">
            <app-echar-line
              :option-data="optionrain"
            />
          </div>
        </b-card>

      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard, BImg,
  // BButton, BBadge,
} from 'bootstrap-vue'
import axios from '@axios'
import * as echarts from 'echarts'
import AppEcharLine from '@/views/vms/detail/garaphLineDB/AppEchartLineDB.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BImg,
    AppEcharLine,
    // BButton,
    // BBadge,
  },
  data() {
    return {
      optionwind: {
        xAxisData: [],
        series: [
          {
            name: 'ความเร็วลม',
            type: 'line',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#FFFFFF' },
                { offset: 1, color: 'rgba(4, 22, 22, 0.5)' },
              ]),
            },
            color: '#FFFFFF',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
        ],
      },
      optionrain: {
        xAxisData: [],
        series: [
          {
            name: 'น้ำฝน',
            type: 'line',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(38, 110, 236, 1)' },
                { offset: 1, color: 'rgba(38, 110, 236, 0.1)' },
              ]),
            },
            color: 'rgba(38, 110, 236, 1)',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
        ],
      },
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getChartWind()
    this.getChartRain()
    this.interval = setInterval(() => {
      this.getVideo()
    }, 300000)
  },
  methods: {
    getChartWind() {
      axios
        .post('/graphVMSWind', { wid: this.$route.query.wid })
        .then(response => {
          this.xAxisDataWind = []
          this.xAxisDataWind = response.data
          this.xAxisDataWind.forEach(value => {
            this.optionwind.xAxisData.push(value.Period_Name)
            this.optionwind.series[0].data.push(value.value)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    getChartRain() {
      axios
        .post('/graphVMSRain', { wid: this.$route.query.wid })
        .then(response => {
          this.xAxisDataRain = []
          this.xAxisDataRain = response.data
          this.xAxisDataRain.forEach(value => {
            this.optionrain.xAxisData.push(value.Period_Name)
            this.optionrain.series[0].data.push(value.value)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style scoped>
.center{
 margin: 0 auto;
 width: 300px;
 display: block;
}
  </style>
